<ll-titulo>Ver Noticia</ll-titulo>
<ver-noticia [noticiaId]="noticiaId"></ver-noticia>
